/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSettlement.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/settlement";

export class AutogenModelSettlement<RowType extends ModelRow> extends Endpoint<RowType, RowSettlementFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSettlement extends ModelRow<RowSettlementFields> {
	constructor(values?: Partial<RowSettlementFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSettlementFields {
	company_id: string;
	deduct_code: string;
	id: string;
	is_active: string;
	payee_currency: string;
	ids: string;
	pay_adjustment_updated: boolean;
}

